import { slice } from './slice';

const { reducer } = slice;

export * from './actions';
export * as infoPopupSelectors from './selectors';

export default reducer;
